// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-3Wj_","col":"styles_col__2IUZn"};